/**
 * 描述：评价系统 ----评价记录 接口管理
 * Created by 钱磊
 * 时间：2022-5-20 11:32:39
 */
 import request from '../../request.js'

  /**
* 描述：评价记录分页列表
* 接口管理员：赵建强
* 参数： 
{
    assProject:'',      // 评价项目
    assName:'',       // 评价方名称
    beAssName:'',      // 被评价方名称
    resource:'',       // 业务系统（码表）
    startDate:'',     // 规则名称
    endDate:'',       // 评价结束时间
    size:10,          // 当前每页条数
    current:1,        // 当前页码
}
*/
export const getAssessRecordPageList = function (data) {
  return request({
      url: '/ngsAssess/selAssessRecordPageList',
      method: 'post',
      requestConfig: {
        hideLoading: true
      },
      data
  })
}

  /**
* 描述：获取评价记录明细
* 接口管理员：赵建强
* 参数： 
{
    id:'',      // id
}
*/
export const getAssessRecordDetail = function (data) {
  return request({
      url: '/ngsAssess/getAssessRecord',
      method: 'post',
      requestConfig: {
        hideLoading: true
      },
      data
  })
}